import React from "react"
import { Box } from "@mui/material"
import DiagonalLabel from "./DiagonalLabel"

type AmbientIndicatorPropsType = {
    label?: string,
    color?: string,
    labelColor?: string
}
const AmbientIndicator: React.FC<AmbientIndicatorPropsType> = ({ label = 'DEV', color = 'forestgreen', labelColor = 'white' }) => {
    if(label === 'PROD') return null;
    return (
        <Box sx={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '54px',
            height: '54px',
            zIndex: 9000
        }}>
            <DiagonalLabel color={color} label={label} labelColor={labelColor} />
        </Box>
    )
}

export default AmbientIndicator